import React from 'react'
import { Box, Button, Container, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import LockIcon from '@mui/icons-material/Lock'

const AccessDenied = () => {
  const navigate = useNavigate()

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '70vh',
          mt: { xs: 8, sm: 10 },
          gap: 3,
          textAlign: 'center'
        }}
      >
        <LockIcon sx={{ fontSize: 100, color: '#FFB534' }} />
        
        <Typography variant="h3" color="error" fontWeight={700}>
          Erişim Reddedildi
        </Typography>
        
        <Typography variant="h6" color="text.secondary" maxWidth="600px">
          Bu sayfaya erişim yetkiniz bulunmamaktadır.
          Lütfen sistem yöneticinizle iletişime geçiniz.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => navigate('/')}
          >
            Ana Sayfaya Dön
          </Button>
          
          <Button
            variant="outlined"
            color="secondary"
            size="large"
            onClick={() => navigate(-1)}
          >
            Geri Git
          </Button>
        </Box>
      </Box>
    </Container>
  )
}

export default AccessDenied
